export default {
  seo: {
    title: 'SEO 设置',
    types: {
      defaultGlobe: '全局默认',
      home: '首页',
      // 兼容老 key
      promotionList: '优惠列表',
      promotionDetail: '优惠详情',
      pointsMall: '积分商城',
      aiRecommend: 'AI 推荐',
      helpCenter: '帮助中心',
      helpArticleDetail: '帮助文章详情',
      // 新后端 typeKey
      'promo-list': '优惠列表',
      'promo-detail': '优惠详情',
      points: '积分商城',
      'ai-picks': 'AI 推荐',
      'help-index': '帮助中心',
      'help-article': '帮助文章详情',
      vip: 'VIP 页面',
      'vip-rules': 'VIP 规则'
    },
    form: {
      searchLabel: '搜索',
      searchPlaceholder: '搜索页面名称 / 关键字',
      query: '查询',
      reset: '重置',
      add: '新增页面',
      languageLabel: '语言',
      languagePh: '请选择语言',
      typeLabel: '页面类型',
      typeAll: '全部',
      statusLabel: '状态',
      statusAll: '全部',
      statusEnabled: '启用',
      statusDisabled: '禁用'
    },
    table: {
      name: '页面名称',
      isGlobalTag: '全局',
      dynamicParams: '动态参数',
      yes: '是',
      no: '否',
      coreSeo: '核心 SEO',
      socialOg: '社交 OG',
      enabled: '启用',
      action: '操作',
      edit: '编辑',
      preview: '预览',
      delete: '删除',
      total: '共 {{count}} 条',
      updatedByText: '更新：{{updatedAt}} · 操作人：{{updatedBy}}',
      keywordPrefix: '关键词：{{text}}',
      ogImageHas: '有图',
      ogImageNone: '无图',
      ogTitleShort: 'OGT：{{text}}',
      ogDescShort: 'OGD：{{text}}',
      ogKeywordShort: 'OGK：{{text}}',
      ogImageConfigured: '已配置',
      ogImageNotConfigured: '未配置'
    },
    modal: {
      createTitle: '新增页面',
      editTitle: '编辑页面',
      previewTitle: '预览',
      fields: {
        type: '页面类型',
        typePh: '请选择页面类型',
        name: '页面名称',
        namePh: '唯一页面标识，例如：home、promotion-detail',
        enabled: '是否启用',
        isGlobal: '是否全局',
        hasOG: '是否包含OG信息',
        hasDynamicParams: '是否动态参数',
        paramNames: '参数名',
        paramNamesPh: '例如：id, slug（英文逗号分隔）',
        title: '标题',
        titlePh: '支持变量：{{pageTitle}}',
        meta: '摘要描述',
        metaPh: '页面摘要',
        canonical: '规范化链接',
        canonicalPh: '规范化链接',
        keyword: '关键词',
        keywordPh: '多个关键词用逗号分隔',
        ogTitle: 'OG Title',
        ogDesc: 'OG 描述',
        ogKeyword: 'OG Keyword',
        ogImage: 'OG 图片',
        ogImagePh: 'https://...'
      },
      ok: '确定',
      cancel: '取消',
      deleteConfirmTitle: '删除确认',
      deleteConfirmContent: '确认删除页面「{{name}}」吗？'
    },
    message: {
      queryFailed: '查询失败',
      createSuccess: '创建成功',
      createFailed: '创建失败',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      opFailed: '操作失败',
      enabled: '已启用',
      disabled: '已禁用',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
};


